import type React from 'react'
import type { HTMLAttributes } from 'react'
import { cn, cva, type VariantProps } from '../lib/cva'

const textVariants = cva('text-current', {
	variants: {
		variant: {
			h1: 'text-6xl font-semibold tracking-[-0.02em]',
			h2: 'text-5xl font-semibold tracking-[-0.02em]',
			h3: 'text-4xl font-semibold tracking-[0.02em]',
			h4: 'text-[28px] font-semibold tracking-[-0.02em]',
			h5: 'text-2xl font-semibold tracking-[-0.02em]',
			h6: 'text-xl font-semibold tracking-[-0.02em]',
			large: 'text-xl',
			medium: 'text-lg',
			small: 'text-base',
			xsmall: 'text-sm',
			hint: 'text-xs',
			none: '',
		},
		weight: {
			regular: 'font-normal block',
			semibold: 'font-semibold block',
		},
	},
	defaultVariants: {
		variant: 'none',
		weight: 'regular',
	},
})

export type TextVariant = VariantProps<typeof textVariants>['variant']
interface TextProps extends HTMLAttributes<HTMLElement>, VariantProps<typeof textVariants> {
	children: React.ReactNode
}

export const Text: React.FC<TextProps> = ({ variant, weight, className, children, ...props }) => {
	const Component = (variant && /^h\d$/.test(variant) ? variant : 'span') as React.ElementType

	return (
		<Component className={cn(textVariants({ variant, weight }), className)} {...props}>
			{children}
		</Component>
	)
}
